var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slides fade",style:({ display: _vm.display })},[_c('img',{attrs:{"alt":_vm.slide.name,"src":_vm.getUrl(_vm.slide.url)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }